'use client';

import { css } from '@linaria/core';

import { label } from '../label/label.styles';
import { input } from '../input/input.styles';
import { control } from '../control/control.styles';
import { select } from '../select/select.styles';

const labelClass = `.${label}`;
const inputClass = `.${input}`;

const inputLabelIsFloating = `+ ${inputClass}:is(:focus, input:not([value='']), textarea:not(:empty))`;

export const field = css`
  display: flex;
  flex-direction: column;
  position: relative;
  --control-height: 50px;

  & > ${labelClass}:has(+ :is(.${input}, .${control}, .${select})) {
    position: absolute;
    pointer-events: none;
    top: 0.75rem;
    left: 1rem;
    transition: all 0.125s ease-in;
    z-index: 10;
    &:has(${inputLabelIsFloating}),
    &:has(+ .${control} ${inputClass}:is(:focus, ${inputClass}:not(:empty), input:not([value='']), textarea:not(:empty))) {
      font-size: 14px;
      top: 0.25rem;
    }
  }

  .${label} {
    + .${control} {
      --control-height: 50px;
    }
    + .${input}, + .${control} .${input}, + .${select} {
      height: 50px;
      padding: 1.5rem 1rem 0.5rem 1rem;
    }
  }
`;
